import React from "react";
import LabelHeading from "../../common/LabelHeading";
import { assets } from "../../../Assets/assets";

const Awards = () => {
  const certificateData = [
    { img: assets.certificate, label: "Magnit Impact Player Award 2024" },
    { img: assets.certificate2, label: "Pinnacle Premier Suppliers 2024" },
    { img: assets.certificate3, label: "MONUMENT CONSULTING AWARD" },
    // { img: assets.certificate, label: "Magnit Impact Player Award 2024" },
    // { img: assets.certificate, label: "Pinnacle Premier Suppliers 2024" },
    // { img: assets.certificate, label: "MONUMENT CONSULTING AWARD" },
  ];

  return (
    <section className="max-w-[1400px] mx-auto px-6 xl:py-20 pt-16 pb-7">
      <LabelHeading
        label="Awards & Recognition"
        heading="Award and Recognition"
        text="We are proud to be recognized with the Magnit Impact Player Award,
        celebrating our strong partnership, market expertise."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8 mt-12 justify-items-stretch place-items-center">
        {certificateData.map(({ img, label }, index) => (
          <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100}
            key={index}
            className="group cursor-pointer transition-all duration-500"
          >
            <div
              className="relative bg-white w-full rounded-lg overflow-hidden border border-gray-200 
              transition-all duration-500 group-hover:shadow-[0px_10px_25px_rgba(0,0,0,0.12)]
              group-hover:border-primaryColor group-hover:-translate-y-2"
            >
              <img
                src={img}
                alt={label}
                className="w-full object-cover"
              />
            </div>

            <p className="text-center text-lg capitalize font-medium mt-4 text-primaryNavyTextColor">
              {label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Awards;
